import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["rowspan"]
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = {
  class: "text-no-wrap",
  style: {"font-size":"60%"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_badge = _resolveComponent("v-badge")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("td", {
    cols: "5",
    rowspan: _ctx.rowspan,
    style: {"width":"8%"}
  }, [
    _createVNode(_component_v_btn, {
      height: "130%",
      width: "100%",
      onClick: _ctx.selectPlayer
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_badge, {
            overlap: "",
            content: _ctx.player.votes,
            value: _ctx.player.votes
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_avatar, { size: "40" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_img, { src: _ctx.playerAvatar }, null, 8, ["src"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["content", "value"]),
          _createElementVNode("p", _hoisted_3, [
            _renderSlot(_ctx.$slots, "name")
          ])
        ])
      ]),
      _: 3
    }, 8, ["onClick"])
  ], 8, _hoisted_1))
}